<template>
  <div class="prog-set-form-right-wrap">
    <Scrollbar class="data-list-right" :show_bar="true" v-if="handle_data.length > 0">
      <div :class="is_show_all ? 'tab-head tab-head-show-all' : 'tab-head'" v-show="!sub_fill_page">
        <div class="tab-head-top" v-if="is_show_all">
          <span class="tab-head-title">Settings</span>
          <i class="tab-head-close" @click="$emit('toggle-panel')"><svg-icon name="close" /></i>
        </div>
        <h2 v-else>Settings</h2>
        <Navi :menu="computed_tab_menus" :type="1" @selected-tab="tab_index = $event + 1;clearTabRedDot()" ref="nav" />
      </div>

      <!-- Application Settings[0] -->
      <div class="set-box" v-if="tab_index === 1">
        <!-- <div class="title-top">
          <div class="title">{{ handle_data[0].name }}</div>
          <Badage class="img-bagage" :value="bagage.value" :type="bagage.color" :border="'4'" />
        </div> -->
        <div class="content-box">
          <!-- Application title & link -->
          <div class="text-box">
            <div class="small-text">
              Application title (internal) & link
              <svg-icon name="pen" @click="$refs.add.open(handle_data[0].section_groups[0].group_setting)" />
            </div>
            <div class="small-text-dec">
              {{ handle_data[0].section_groups[0].group_setting[0].input_value }}
            </div>
            <tippy :content="url_link">
              <a :href="url_link" target="_blank" class="url url-link-one-line">
                {{ url_link }}
              </a>
            </tippy>
          </div>

          <!-- TODO TEMP: Default creator account type - WAIT FOR API NEW FIELD -->
          <div class="text-box account-type-section" v-if="!link_only">
            <div class="small-text had-required">Default creator account type<span class="required-red" v-if="application_status === 'draft'">*</span></div>
            <div v-if="application_status === 'draft'">
              <p class="desc">
                Select the account types available to your creators. If both are selected, you will be prompted to choose
                an account experience for each individual creator upon approval.
                <span class="note">Note: This selection cannot be changed once published.</span>
              </p>
              <div class="account-type-checks">
                <label class="account-type-check-label" >
                  <input type="checkbox" v-model="account_type_storefront" @change="if (account_type_storefront) account_type_shortlink = true; else if (!account_type_shortlink) account_type_storefront = true; emit('update-account-type', { storefront: account_type_storefront, shortlink: account_type_shortlink })" />
                  Storefront
                </label>
                <label class="account-type-check-label">
                  <input type="checkbox" v-model="account_type_shortlink" @change="if (!account_type_shortlink && account_type_storefront) account_type_shortlink = true; else if (!account_type_storefront && !account_type_shortlink) account_type_shortlink = true; emit('update-account-type', { storefront: account_type_storefront, shortlink: account_type_shortlink })" />
                  Shortlink
                </label>
              </div>
            </div>
            <div v-else>
              <p class="desc">
                {{ account_type_storefront && account_type_shortlink ? 'Flexible' : account_type_storefront ? 'Storefront' : 'Shortlink' }}
              </p>
            </div>
          </div>

          <!-- Accepting applications (moved up from bottom of general block) -->
          <div class="text-box" v-if="application_status !== 'draft'">
            <div class="small-text">
              <div class="small-text-left">
                {{ handle_data[0].section_groups[1].group_setting[2].client_view.name }}
                <tippy :content="handle_data[0].section_groups[1].group_setting[2].client_view.desc">
                  <svg-icon name="question" class="tip-icon" />
                </tippy>
              </div>
              <div class="switch-with-label">
                <span :class="['switch-state-text', handle_data[0].section_groups[1].group_setting[2].client_view.show ? 'state-open' : 'state-closed']">
                  {{ handle_data[0].section_groups[1].group_setting[2].client_view.show ? 'Accepting' : 'Stop accepting' }}
                </span>
                <Switch
                  :checked="handle_data[0].section_groups[1].group_setting[2].client_view.show"
                  @click.native="
                    handle_data[0].section_groups[1].group_setting[2].client_view.show = !handle_data[0].section_groups[1].group_setting[2].client_view.show;
                    $emit('update-data', { data: handle_data });
                  "
                />
              </div>
            </div>
          </div>

          <!-- Application period (UTC) -->
          <div class="text-box">
            <div class="small-text">Application period (UTC)</div>
            <div class="desc">Automatically open application when published.</div>
          </div>

          <div
            class="date-box"
            v-for="(v, k) in handle_data[0].section_groups[1].group_setting.filter((e, kk) => {
              return kk <= 1;
            })"
            :key="k"
          >
            <div class="title">
              <div class="title-left">
                {{ v.client_view.name }} 
                <tippy :content="v.client_view.desc">
                  <svg-icon name="question" class="tip-icon" />
                </tippy>
              </div>
              <Switch
                :checked="v.client_view.show"
                @click.native="
                  v.client_view.show = v.client_view.show ? false : true;
                  $emit('update-data', { data: handle_data });
                "
              />
            </div>
            <div class="show" v-show="v.client_view.show">
              <DateTimePicker
                :date="v.client_view.date"
                :time="v.client_view.time"
                :datetime="v.client_view.val"
                :format="v.client_view.plac"
                @update-date="calendarChange"
                @update-time="timeChange"
                :spec_val="v.client_view.name"
                :max_date="v.client_view.max_date ? v.client_view.max_date : null"
                :min_date="v.client_view.min_date ? v.client_view.min_date : null"
              />
            </div>
          </div>

          <!-- Submission message (moved from Response tab) -->
          <div
            class="text-box"
            v-for="(v, k) in handle_data[1].section_groups.filter((e) => {
              return e.tip === 'sub-mes';
            })"
            :key="'sub-' + k"
          >
            <div class="small-title-box">
              <p>{{ v.name }}</p>
              <div class="small-title-box-right">
                <div class="open-pre" @click="openPreview(v)">Preview</div>
                <svg-icon name="pen" @click="openTanking(v)" />
              </div>
            </div>
            <div class="sub-mes-box" v-for="(vv, kk) in v.group_setting" :key="kk">
              <div class="s-tit">{{ vv.client_view.name }}:</div>
              <div class="desc" v-if="!vv.client_view.is_edit">
                {{ vv.client_view.val ? vv.client_view.val : vv.client_view.plac }}
              </div>
              <Field
                v-else
                :type="vv.client_view.client_type"
                :k="v.group_name"
                :placeholder="vv.client_view.plac"
                :had_value="vv.client_view.val"
                @update="update"
                :ref="
                  (el) => {
                    els.push(el);
                  }
                "
                :spec="kk"
                :max_value="vv.client_view.max_value"
              />
            </div>
          </div>

        </div>
      </div>

      <!-- Automations[1] -->
      <div class="set-box" v-if="tab_index === 2">
        <div class="content-box">

          <template
            v-for="(v, k) in handle_data[1].section_groups.filter((e) => e.tip === 'application' && e.group_name !== 'auto_enable_account_activation')"
            :key="'auto-' + k"
          >
             <div class="automation-group-title" v-if="v.group_name === 'application_receipt'">Submission Automation</div>
            <div class="automation-group-title" v-if="v.group_name === 'application_approved'">Approval Automation</div>
            <div class="automation-group-title" v-if="v.group_name === 'application_reject'">Rejection Automation</div>
            
            <!-- Hardcoded Auto-enable account activation switch -->
            <div class="auto-item" v-if="v.group_name === 'application_storefront_invite'">
              <div class="auto-row">
                <div class="auto-row-left">
                  <span>Auto-enable account activation</span>
                  <tippy content="When enabled, creators approved immediately count towards your creator seat limit and can launch on immediately. When turned off, creators who receive approval emails will need to be separately invited to launch within the Recruitment dashboard."><svg-icon name="question"/></tippy>
                </div>
                <Switch :checked="enableActivationSwitch" @click.native="toggleEnableActivation" />
              </div>
            </div>

            <div
              class="switch-open-content"
              v-if="v.group_name === 'application_storefront_invite'"
              v-show="!enableActivationSwitch"
            >
              <div class="auto-item">
                <div class="auto-row">
                  <div class="auto-row-left">
                    <span>{{ v.name }}</span>
                    <tippy :content="v.desc" v-if="v.desc"><svg-icon name="question"/></tippy>
                  </div>
                  <Switch :checked="v.is_switch" @click.native="switchOneResonse(v)" />
                </div>
                <template v-if="v.is_switch && checkScIndex(v) !== -1">
                  <div class="sch-label">Delivery schedule</div>
                  <el-select
                    class="sch-select"
                    popper-class="select-above-modal"
                    v-model="v.group_setting[checkScIndex(v)].client_view.val"
                    @change="(newMode) => handleSendModeChange(v, newMode)"
                  >
                    <el-option value="immediately" label="Immediately" />
                    <el-option value="scheduled" label="Scheduled" />
                    <el-option value="delay" label="Delay" />
                  </el-select>
                  <div
                    :class="['date-time-pick-box', v.group_setting[checkTimeIndex(v)].client_view.err && 'date-time-pick-box-err']"
                    v-if="v.group_setting[checkScIndex(v)].client_view.val === 'scheduled' && checkTimeIndex(v) !== -1"
                  >
                    <div class="desc">Applicant will receive email at the following time (UTC):</div>
                    <DateTimePicker
                      :key="v.group_setting[checkTimeIndex(v)].client_view.refrash_key"
                      :date="v.group_setting[checkTimeIndex(v)].client_view.date"
                      :time="v.group_setting[checkTimeIndex(v)].client_view.time"
                      :datetime="v.group_setting[checkTimeIndex(v)].client_view.val"
                      :format="v.group_setting[checkTimeIndex(v)].client_view.plac"
                      @update-date="calendarChange"
                      @update-time="timeChange"
                      :spec_val="v.group_setting[checkTimeIndex(v)].client_view.name"
                      :min_date="inviteScheduledMinDate"
                      :index="v.index"
                    />
                  </div>
                  <!-- delay 欄位使用獨立的 _receive_unit / _receive_unitValue group_setting -->
                  <div class="delay-box" v-if="v.group_setting[checkScIndex(v)].client_view.val === 'delay' && checkDelayValIndex(v) !== -1 && checkDelayUnitIndex(v) !== -1">
                    <div class="desc">Delay email send:</div>
                    <div class="delay-inputs">
                      <input
                        class="delay-num-input"
                        type="number"
                        min="1"
                        max="60"
                        v-model.number="v.group_setting[checkDelayValIndex(v)].client_view.val"
                        @input="v.group_setting[checkDelayValIndex(v)].client_view.val = Math.min(60, Math.max(1, parseInt($event.target.value) || 1)); $emit('update-data', { data: handle_data })"
                      />
                      <el-select
                        class="delay-unit-select"
                        popper-class="select-above-modal"
                        v-model="v.group_setting[checkDelayUnitIndex(v)].client_view.val"
                        @change="$emit('update-data', { data: handle_data })"
                      >
                        <el-option value="minutes" label="Minutes" />
                        <el-option value="hours" label="Hours" />
                        <el-option value="days" label="Days" />
                      </el-select>
                    </div>
                    <div class="delay-hint">Number must be between 1 - 60.</div>
                  </div>
                  <!-- Invite 時間衝突警告 -->
                  <div v-if="inviteTimeError" class="time-conflict-warning">
                    <svg-icon name="alert" />
                    <p v-html="inviteTimeError "></p>
                  </div>
                </template>
              </div>
            </div>

            <div class="auto-item" v-else>
              <div class="auto-row">
                <div class="auto-row-left">
                  <span>{{ v.name }}</span>
                  <tippy :content="v.desc" v-if="v.desc"><svg-icon name="question"/></tippy>
                </div>
                <Switch :checked="v.is_switch" @click.native="switchOneResonse(v)" />
              </div>
              <template v-if="v.is_switch && checkScIndex(v) !== -1">
                <div class="switch-open-content">
                  <div class="sch-label">Delivery schedule</div>
                  <el-select
                    class="sch-select"
                    popper-class="select-above-modal"
                    v-model="v.group_setting[checkScIndex(v)].client_view.val"
                    @change="(newMode) => handleSendModeChange(v, newMode)"
                  >
                    <el-option value="immediately" label="Immediately" />
                    <el-option value="scheduled" label="Scheduled" />
                    <el-option value="delay" label="Delay" />
                  </el-select>
                  <div
                    :class="['date-time-pick-box', v.group_setting[checkTimeIndex(v)].client_view.err && 'date-time-pick-box-err']"
                    v-if="v.group_setting[checkScIndex(v)].client_view.val === 'scheduled' && checkTimeIndex(v) !== -1"
                  >
                    <div class="desc">Applicant will receive email at the following time (UTC):</div>
                    <DateTimePicker
                      :key="v.group_setting[checkTimeIndex(v)].client_view.refrash_key"
                      :date="v.group_setting[checkTimeIndex(v)].client_view.date"
                      :time="v.group_setting[checkTimeIndex(v)].client_view.time"
                      :datetime="v.group_setting[checkTimeIndex(v)].client_view.val"
                      :format="v.group_setting[checkTimeIndex(v)].client_view.plac"
                      @update-date="calendarChange"
                      @update-time="timeChange"
                      :spec_val="v.group_setting[checkTimeIndex(v)].client_view.name"
                      :min_date="minDate(v.group_setting[checkTimeIndex(v)].label)"
                      :index="v.index"
                    />
                  </div>
                  <div class="delay-box" v-if="v.group_setting[checkScIndex(v)].client_view.val === 'delay' && checkDelayValIndex(v) !== -1 && checkDelayUnitIndex(v) !== -1">
                    <div class="desc">Delay email send:</div>
                    <div class="delay-inputs">
                      <input
                        class="delay-num-input"
                        type="number"
                        min="1"
                        max="60"
                        v-model.number="v.group_setting[checkDelayValIndex(v)].client_view.val"
                        @input="v.group_setting[checkDelayValIndex(v)].client_view.val = Math.min(60, Math.max(1, parseInt($event.target.value) || 1)); $emit('update-data', { data: handle_data })"
                      />
                      <el-select
                        class="delay-unit-select"
                        popper-class="select-above-modal"
                        v-model="v.group_setting[checkDelayUnitIndex(v)].client_view.val"
                        @change="$emit('update-data', { data: handle_data })"
                      >
                        <el-option value="minutes" label="Minutes" />
                        <el-option value="hours" label="Hours" />
                        <el-option value="days" label="Days" />
                      </el-select>
                    </div>
                    <div class="delay-hint">Number must be between 1 - 60.</div>
                  </div>
                  <div v-if="scheduledPastWarning(v)" class="time-conflict-warning">
                    <svg-icon name="alert" />
                    <p v-html="scheduledPastWarning(v)"></p>
                  </div>
                </div>
              </template>
            </div>
          </template>

          <!-- Enable auto-rejection settings -->
          <div class="auto-item" v-if="!autoRejAllHide">
            <div class="auto-row">
              <div class="auto-row-left">
                <span>{{ handle_data[3].name }}</span>
                <tippy :content="handle_data[3].desc">
                  <svg-icon name="question" />
                </tippy>
              </div>
              <Switch
                :checked="autoRejAllHide || !otherGroupsOpen ? false : handle_data[3].section_groups[0].is_switch"
                @click.native="switchOneAuto(0, autoRejDis)"
              />
            </div>
          </div>
          <!-- Auto-Rejection content - shown when Enable auto-rejection settings is ON -->
          <div class="auto-rej-content switch-open-content" v-if="!autoRejAllHide && otherGroupsOpen && handle_data[3].section_groups[0].is_switch">

            <!-- age -->
            <div class="text-box" v-if="$ProjectName !== 'sephora'">
            <div class="small-text">
              {{ handle_data[3].section_groups[1].name }}
              <Switch :checked="handle_data[3].section_groups[1].is_switch" @click.native="switchOneAuto(1, autoRejDis.age)" />
            </div>
            <div v-if="handle_data[3].section_groups[1].is_switch">
              <div class="desc">{{ handle_data[3].section_groups[1].desc }}</div>
              <div
                :class="['value-box', v.client_view.err && 'value-box-err']"
                v-for="(v, k) in handle_data[3].section_groups[1].group_setting"
                :key="k"
              >
                <div class="left-text">{{ v.client_view.name }} <span v-if="k === 0" class="red"> *</span></div>
                <Field
                  :type="'number'"
                  :k="v.label"
                  :placeholder="v.client_view.plac"
                  :had_value="v.client_view.val"
                  :error_msg="handle_data[3].section_groups[1].error_msg && !handle_data[3].section_groups[1].group_setting[0].client_view.err"
                  :no_show_err_msg="true"
                  :spec="'age-check'"
                  @update="update"
                  :ref="(el) => { els.push(el) }"
                />
              </div>
              <div class="err-msg" v-if="handle_data[3].section_groups[1].error_msg">{{ handle_data[3].section_groups[1].error_msg }}</div>
            </div>
          </div>

          <!-- location -->
          <div class="text-box">
            <div class="small-text">
              {{ handle_data[3].section_groups[2].name }}
              <Switch :checked="handle_data[3].section_groups[2].is_switch" @click.native="switchOneAuto(2, autoRejDis.loc)" />
            </div>
            <div v-if="handle_data[3].section_groups[2].is_switch">
              <div class="desc">{{ handle_data[3].section_groups[2].desc }}</div>
              <div class="select-box">
                <Dropdown
                  :items="handle_data[3].section_groups[2].group_setting[0].client_view.input_option"
                  :icon_direction_type="'none'"
                  @update-dropdown="updateLocation"
                  :only_pick="true"
                />
                <ul>
                  <div class="ul-box">
                    <li v-for="(item, tagIndex) in handle_data[3].section_groups[2].group_setting[0].client_view.val" :key="tagIndex">
                      <Button size="24" color="black-10" :border_r="'4'">
                        {{ item.text }}
                        <i @click="remove(item)"><svg-icon name="remove" /></i>
                      </Button>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
          </div>

          <!-- follower count -->
          <div class="text-box">
            <div class="small-text">
              {{ handle_data[3].section_groups[3].name }}
              <Switch :checked="handle_data[3].section_groups[3].is_switch" @click.native="switchOneAuto(3, autoRejDis.follow)" />
            </div>
            <div v-if="handle_data[3].section_groups[3].is_switch">
              <div class="desc">{{ handle_data[3].section_groups[3].desc }}</div>
              <div class="value-box">
                <div class="left-text"><svg-icon name="tiktok" /></div>
                <div class="flex" @click="handleSocAlert('tk')">
                  <Field
                    v-for="(v, k) in handle_data[3].section_groups[3].group_setting.filter((e) => e.type === 'tk')"
                    :key="k"
                    :type="'number'"
                    :k="v.label"
                    :placeholder="v.client_view.plac"
                    :had_value="v.client_view.val"
                    :is_disabled="!handle_data[3].section_groups[3].tk_show"
                    :no_show_err_msg="true"
                    :spec="'tk-follow'"
                    @update="update"
                    :ref="(el) => { els.push(el) }"
                  />
                </div>
              </div>
              <div class="value-box">
                <div class="left-text"><svg-icon name="instagram" /></div>
                <div class="flex" @click="handleSocAlert('ig')">
                  <Field
                    v-for="(v, k) in handle_data[3].section_groups[3].group_setting.filter((e) => e.type === 'ig')"
                    :key="k"
                    :type="'number'"
                    :k="v.label"
                    :placeholder="v.client_view.plac"
                    :had_value="v.client_view.val"
                    :is_disabled="!handle_data[3].section_groups[3].ig_show"
                    :no_show_err_msg="true"
                    :spec="'ig-follow'"
                    @update="update"
                    :ref="(el) => { els.push(el) }"
                  />
                </div>
              </div>
              <Checkbox
                size="small"
                class="follow-check"
                :label_text="' Require applicants to meet both minimums for authenticated accounts.'"
                :checked="followIndex === 0"
                @click="checkFollowIndex()"
                :disabled="!checkFollow()"
              />
            </div>
          </div>
          </div><!-- /auto-rej-content -->
        </div><!-- /content-box -->
      </div><!-- /set-box tab_index===2 -->

      <!-- Emails tab -->
      <div class="set-box" v-if="tab_index === 3">
        <div class="content-box emails-content">

          <!-- Application Submission Receipt -->
          <template v-for="v in handle_data[1].section_groups.filter(e => e.group_name === 'application_receipt')" :key="v.group_name">
            <div class="email-row">
              <span class="email-row-title row-title-big">Application Submission Receipt</span>
              <div class="email-row-actions">
                <span class="send-test-link" @click="sendTestEmail(v)">Send me a test</span>
                <div
                  :class="['edit-btn', is_new_map[v.group_name] && 'edit-btn-dot', !permission_recruitment?.editEmailTemplates?.permission && 'dis-edit-box']"
                  @click="clearEmailRedDot(v); $refs.editResTemplate.open(v)"
                >
                  <svg-icon name="pen" /> Edit
                  <span class="dot-badge" v-if="is_new_map[v.group_name]"></span>
                </div>
              </div>
            </div>
          </template>

          <!-- Approval emails -->
          <div class="email-section-group">
            <div class="email-section-group-title">Approval emails</div>
            <template v-for="v in handle_data[1].section_groups.filter(e => e.group_name === 'application_approved' || (!link_only && e.group_name === 'application_approved_shortlink') || e.group_name === 'application_storefront_invite').sort((a, b) => a.group_name === 'application_storefront_invite' ? 1 : b.group_name === 'application_storefront_invite' ? -1 : 0)" :key="v.group_name">
              <div class="email-row">
                <span class="email-row-title">{{
                  v.group_name === 'application_approved' ? 'Storefront Approval' :
                  v.group_name === 'application_approved_shortlink' ? 'Shortlink Approval' :
                  'Invite emails'
                }}</span>
                <div class="email-row-actions">
                  <span class="send-test-link" @click="sendTestEmail(v)">Send me a test</span>
                  <div
                    :class="['edit-btn', is_new_map[v.group_name] && 'edit-btn-dot', !permission_recruitment?.editEmailTemplates?.permission && 'dis-edit-box']"
                    @click="clearEmailRedDot(v); $refs.editResTemplate.open(v)"
                  >
                    <svg-icon name="pen" /> Edit
                    <span class="dot-badge" v-if="is_new_map[v.group_name]"></span>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <!-- Rejection email -->
          <div class="email-section-group">
            <template v-for="v in handle_data[1].section_groups.filter(e => e.group_name === 'application_reject')" :key="v.group_name">
              <div class="email-row">
                <span class="email-row-title row-title-big">Rejection email</span>
                <div class="email-row-actions">
                  <span class="send-test-link" @click="sendTestEmail(v)">Send me a test</span>
                  <div
                    :class="['edit-btn', is_new_map[v.group_name] && 'edit-btn-dot', !permission_recruitment?.editEmailTemplates?.permission && 'dis-edit-box']"
                    @click="clearEmailRedDot(v); $refs.editResTemplate.open(v)"
                  >
                    <svg-icon name="pen" /> Edit
                    <span class="dot-badge" v-if="is_new_map[v.group_name]"></span>
                  </div>
                </div>
              </div>
            </template>
          </div>

        </div>
      </div>

      <div class="set-box" v-if="!is_show_all" v-show="tab_index === 4">
        <ProgAgreement :data="data.agreements_disclaimers" :brand_name="brand_name" ref="pa" />
      </div>

      <div class="set-box" v-if="!is_show_all" v-show="tab_index === 5">
        <ProgParentEdit
          :data="data.parent_guardian_consent"
          :hide_head="true"
          ref="pp"
          @hide="
            data.block_status.find((o) => o.name === 'parent_guardian_consent').open = !data.block_status.find(
              (o) => o.name === 'parent_guardian_consent'
            ).open
          "
          :is_need="data.block_status.find((o) => o.name === 'parent_guardian_consent').open"
        />
      </div>
    </Scrollbar>

    <footer class="foot-box" v-if="!is_show_all">
      <el-button @click="$emit('close')">Cancel</el-button>
      <el-button type="primary" @click="save(1)" :disabled="!is_can_save || !is_inited || hasAnyTimeError">Save & apply</el-button>
    </footer>

    <AddProgramPop
      ref="add"
      @save="saveTitle"
      :need_des="true"
      :is_edit="is_edit"
      :ambassador_application_id="ambassador_application_id"
      :application_status="application_status"
    />
    <EditResTemplate
      ref="editResTemplate"
      :handle_data="handle_data"
      @calendarChange="calendarChange"
      @timeChange="timeChange"
      @emailSave="emailSave"
      @updateData="updateDataInSide"
      :ambassador_application_id="ambassador_application_id"
      :ambassador_application_name="title"
    />

    <FormForUserFillin @close="sub_fill_page = false" />
    <SubMesEditPop ref="submes" @openPre="openPreview" @save="saveTanking" />
  </div>
  <Modal :is_show="is_show_save_modal" class="alert-modal" @click-bg="is_show_save_modal = false">
    <div class="box">
      <header class="delete-header">Update application?</header>
      <p>Changes to your settings will be reflected with future applicants and will not affect any prior applicants.</p>
      <div class="btns">
        <el-button @click="is_show_save_modal = false">Cancel</el-button>
        <el-button
          type="primary"
          @click="
            is_show_save_modal = false;
            save(2);
          "
          >Save</el-button
        >
      </div>
    </div>
  </Modal>

  <!-- <Modal :is_show="is_show_alert_modal" class="alert-modal" @click-bg="is_show_alert_modal = false">
        <div class="box">
            <header class="delete-header">{{alert.header}}</header>
            <div class="btns">
                <Button type="button" :border_r="6" color="dark-blue" size="32" @click="is_show_alert_modal = false">Ok</Button>
            </div>
        </div>
    </Modal> -->

  <Modal :is_show="is_show_alert2_modal" class="application-alert-modal2" @click-bg="is_show_alert2_modal = false">
    <div class="box">
      <header class="delete-header">
        <h2>Action required</h2>
        <i @click="is_show_alert2_modal = false"><svg-icon name="close" /></i>
      </header>
      <div class="content">
        <img :src="alert.img" alt="img" />

        <h3>{{ alert.header }}</h3>
        <div v-html="alert.text"></div>
        <el-button type="primary" @click="is_show_alert2_modal = false">Ok</el-button>
      </div>
    </div>
  </Modal>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { ElButton, ElSelect, ElOption } from 'element-plus';
import Modal from '@/components/ui/Modal.vue';
import Field from '@/components/ui/Field.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Switch from '@/components/ui/Switch.vue';
import DateTimePicker from '@/components/ui/DateTimePicker.vue';
import moment from 'moment';
import Badage from '@/components/ui/Badage.vue';
import { checkScIndex, checkTimeIndex, checkDelayUnitIndex, checkDelayValIndex } from '@/utils/ProgramsData.js';
import AddProgramPop from '@/components/programs/AddProgramPop.vue';
import EditResTemplate from '@/components/programs/Form/EditResTemplate.vue';
import ProgAgreement from './ProgAgreement.vue';
import Navi from '@/components/Navi.vue';
import ProgParentEdit from './ProgParentEdit.vue';
import FormForUserFillin from './FormForUserFillIn.vue';
import SubMesEditPop from './SubMesEditPop.vue';

const store = useStore();
const { proxy } = getCurrentInstance();
const ajax = proxy.$ajax;
// ─── props ────────────────────────────────────────────────────────
const props = defineProps({
  data: { type: Object, default: () => ({}) },
  is_edit: { type: Boolean, default: false },
  title: { type: String, default: '' },
  type: { type: String, default: 'create' },
  is_show_all: { type: Boolean, default: false },
  application_status: { type: String, default: '' },
  ambassador_application_id: { type: Number, required: true },
  ambassador_application_name: { type: String, default: '' },
});

const emit = defineEmits(['update-data', 'toggle-panel', 'save', 'close', 'invite-time-error', 'update-account-type']);

// ─── template refs ────────────────────────────────────────────────
const nav = ref(null);
const add = ref(null);
const editResTemplate = ref(null);
const submes = ref(null);
const pa = ref(null);
const pp = ref(null);

// ─── state ────────────────────────────────────────────────────────
const tab_index = ref(1);
const values = ref({});
const handle_data = ref([]);
const els = ref([]);
const auto_email = ref(false);
const enableActivationSwitch = ref(false);
const location_pick = ref([]);
const backup_data = ref([]);
const is_inited = ref(false);
const is_show_save_modal = ref(false);
const is_show_alert_modal = ref(false);
const is_show_alert2_modal = ref(false);
const alert = reactive({ header: '', img: '', text: '' });
const followIndex = ref(1);
const account_type_storefront = ref(false);
const account_type_shortlink = ref(false);
// automations / emails 對應 tab 紅點；group_name key 對應各 email 列的紅點
const is_new_map = ref({
  automations: true,
  emails: true,
  application_receipt: true,
  application_approved: true,
  application_storefront_invite: true,
  application_reject: true,
  application_approved_shortlink: true,
});

const dot_automations = computed(() => !!is_new_map.value.automations);
const dot_emails = computed(() =>
  !!is_new_map.value.emails ||
  !!is_new_map.value.application_receipt ||
  !!is_new_map.value.application_approved ||
  !!is_new_map.value.application_storefront_invite ||
  !!is_new_map.value.application_reject ||
  !!is_new_map.value.application_approved_shortlink
);
// Agreement & Guardian Consent tabs (only appended when !is_show_all in getData)
const extra_tab_menus = ref([]);
const sub_fill_page = ref(false);

// ─── computed ─────────────────────────────────────────────────────
const computed_tab_menus = computed(() => {
  const dot = '<span class="nav-red-dot"></span>';
  return [
    { text: 'Application' },
    { text: `Automations${dot_automations.value ? dot : ''}` },
    { text: `Emails${dot_emails.value ? dot : ''}` },
    ...extra_tab_menus.value,
  ];
});

const permission_recruitment = computed(() => store.state.user_data?.permission_list?.recruitment);

const link_only = computed(() => {
    return permission_recruitment.value?.manageCandidates?.permission === 0;
});

const url_link = computed(() => {
  const url = store.state.user_data
    ? store.state.user_data.merchant_account.anchor_ambassador_subdomain
    : `${store.state.user_data.merchant_account.merchant_display_name}.anchor.store`;
  return `${url}/p/${handle_data.value[0].section_groups[0].group_setting[1].input_value}`;
});

const is_can_save = computed(
  () =>
    !(
      JSON.stringify(handle_data.value) === JSON.stringify(backup_data.value.settings) &&
      JSON.stringify(props.data.agreements_disclaimers) === JSON.stringify(backup_data.value.agreements_disclaimers) &&
      JSON.stringify(props.data.block_status) === JSON.stringify(backup_data.value.block_status) &&
      JSON.stringify(props.data.parent_guardian_consent) === JSON.stringify(backup_data.value.parent_guardian_consent)
    )
);

const brand_name = computed(() => store.state.user_data.merchant_account.merchant_display_name);

const bagage = computed(() => {
  if (props.application_status === 'draft' || !props.application_status) return { value: 'Draft', color: 'dis' };
  if (props.application_status === 'closed') return { value: 'Closed', color: 'dis' };
  if (props.application_status === 'scheduled') return { value: 'Scheduled', color: 'sch' };
  return { value: 'Active', color: 'act' };
});

const autoRejDis = computed(() => ({
  age: !handle_data.value[3].section_groups[1].showtoUser,
  loc: !handle_data.value[3].section_groups[2].showtoUser,
  follow:
    !handle_data.value[3].section_groups[3].showtoUser ||
    (!handle_data.value[3].section_groups[3].tk_show && !handle_data.value[3].section_groups[3].ig_show),
  tk_f: !handle_data.value[3].section_groups[3].tk_show,
  ig_f: !handle_data.value[3].section_groups[3].ig_show,
}));

const autoRejAllHide = computed(() => {
  const sectionGroups = handle_data.value[3]?.section_groups ?? [];
  // 跳第0个元素
  const otherGroupsCheck = sectionGroups.slice(1).every((group, index) => {
    if (index === 2) {
      // index = 3 in the original array since we're slicing from 1
      // 如果唯一为 true 的是 index = 3，则检查 tk_show 和 ig_show
      if (group.showtoUser === true) {
        return !(group.tk_show === true || group.ig_show === true); // 如果 tk_show 和 ig_show 都为 false，则返回 true
      }
    }
    // 如果 showtoUser 是 true，且不是 index = 3，直接返回 false
    return group.showtoUser === false;
  });
  return otherGroupsCheck;
});

const otherGroupsOpen = computed(() => {
  const sectionGroups = handle_data.value[3]?.section_groups ?? [];
  // 跳第0个元素
  return sectionGroups.slice(1).some((group) => group.is_switch);
});

// ─── watch ────────────────────────────────────────────────────────
watch(
  () => props.title,
  (val) => {
    if (val) handle_data.value[0].section_groups[0].group_setting[0].input_value = val;
  }
);

watch(autoRejAllHide, (val) => {
  hanldeAutoRe(val);
});

// ─── methods ──────────────────────────────────────────────────────
const minDate = (label) => {
  const current_utc_date = moment.utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss');
  if (label === 'application_storefront_invite_receive_date') {
    const application_approved = handle_data.value[1].section_groups.find(
      (e) => e.group_name === 'application_approved'
    );
    const application_approved_date = application_approved.group_setting.find(
      (e) => e.label === 'application_approved_receive_date'
    );
    const application_approved_send_mode = application_approved.group_setting.find(
      (e) => e.label === 'application_approved_send_mode'
    );
    console.log(application_approved);
    if (
      application_approved.is_switch &&
      application_approved_send_mode.client_view.val === 'scheduled' &&
      application_approved_date.client_view.val
    ) {
      return application_approved_date.client_view.val;
    } else {
      return current_utc_date;
    }
  } else {
    return current_utc_date;
  }
};

const openTanking = (val) => {
  submes.value.open(val);
};

const openPreview = (v) => {
  sub_fill_page.value = true;
  console.log(v);
  proxy.EventBus.emit('open-form-fillin', {
    data: v,
    title: handle_data.value[0].section_groups[0].group_setting[0].input_value,
  });
};

const save = (type) => {
  if (type === 1) {
    is_show_save_modal.value = true;
    return;
  }
  let agreements_disclaimers = [];
  let parent_guardian_consent = [];
  if (props.data.agreements_disclaimers && props.data.agreements_disclaimers.length !== 0)
    agreements_disclaimers = pa.value.save(true);
  if (props.data.parent_guardian_consent && props.data.parent_guardian_consent.length !== 0)
    parent_guardian_consent = pp.value.save(true);
  setTimeout(() => {
    emit('save', {
      settings: props.data.settings,
      agreements_disclaimers,
      parent_guardian_consent,
      is_storefront: account_type_storefront.value,
      is_shortlink: account_type_shortlink.value,
      is_open: props.data.block_status.find((o) => o.name === 'parent_guardian_consent').open,
    });
  }, 10);
};

const fetchIsNewApi = () => {
  if (props.ambassador_application_id === 1 || !props.ambassador_application_id) {
    return Promise.resolve({});
  }
  return proxy.$ajax('/ambassador/section-seen', {
    method: 'get',
    params: { ambassador_application_id: props.ambassador_application_id },
  }).then(res => res.data?.data ?? {}).catch(err => {
    console.error('Error fetching is_new data:', err);
    return {};
  });
}

watch(is_new_map, (val) => {
  if (props.ambassador_application_id === 1 || !props.ambassador_application_id) {
    const allFalse = Object.values(val).every(v => !v);
    if (allFalse) {
      localStorage.removeItem('is_new_map_pending');
    } else {
      localStorage.setItem('is_new_map_pending', JSON.stringify(val));
    }
  }
}, { deep: true });

const getData = async() => {
  if (!props.is_show_all) {
    if (props.data.agreements_disclaimers && props.data.agreements_disclaimers.length !== 0) {
      extra_tab_menus.value.push({ text: 'Agreement & Disclosure' });
    }
    if (props.data.parent_guardian_consent && props.data.parent_guardian_consent.length !== 0) {
      extra_tab_menus.value.push({ text: 'Guardian Consent' });
    }
  }
  handle_data.value = props.data.settings;

  const apiMap = await fetchIsNewApi();
  if (Object.keys(apiMap).length) is_new_map.value = apiMap;
  account_type_storefront.value = props.data.is_storefront;
  account_type_shortlink.value = props.data.is_shortlink;

  const autoActivationGroup = handle_data.value[1].section_groups.find((e) => e.group_name === 'auto_enable_account_activation');
  if (autoActivationGroup) enableActivationSwitch.value = autoActivationGroup.is_switch;

  handle_data.value[3].section_groups[3].group_setting.forEach((e) => {
    if (e.label === 'auto_rejection_social_follower_count_condition') {
      followIndex.value = e.client_view.val === 'AND' ? 0 : e.client_view.val === 'OR' ? 1 : null;
    }
  });
  const arr = handle_data.value[1].section_groups.filter((e) => e.tip === 'application');
  auto_email.value = arr.some((e) => e.is_switch);
  // What's happening here? Why is the data being processed twice???
  setTimeout(() => {
    // Waiting for data processing to complete
    backup_data.value = JSON.parse(JSON.stringify(props.data));
    is_inited.value = true;
  }, 1000);
  hanldeAutoRe(autoRejAllHide.value);
};

const hanldeAutoRe = (val) => {
  // Auto-rejection is now embedded inside the Automations tab (Rejection Automation section)
  // No separate tab to show/hide - just disable the switch when autoRejAllHide is true
  if (val) {
    handle_data.value[3].section_groups[0].is_switch = false;
  }
};

//++++++++++++++++++++++++++++++++++++++++++
//makeing time
//++++++++++++++++++++++++++++++++++++++++++
const combineDateTime = (dateString, timeString) => {
  // 使用 moment 解析日期和時間
  let date = moment(dateString, handle_data.value[0].section_groups[1].group_setting[0].client_view.plac);
  let time;
  // 檢查 timeString 是否為完整的日期時間格式
  if (moment(timeString, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
    // 如果是完整的日期時間格式，直接解析
    time = moment(timeString, 'YYYY-MM-DD HH:mm:ss');
  } else if (/^\d{1,2}:\d{2} [APMapm]{2}$/.test(timeString)) {
    // 如果是12小時制時間格式
    time = moment(timeString, 'h:mm A');
  } else if (timeString && timeString.includes(' ')) {
    // 如果包含空格（可能是其他日期時間格式）
    time = moment(timeString, 'YYYY-MM-DD HH:mm:ss');
  } else {
    // 默認情況下，使用當前時間
    time = moment();
  }
  // 設置日期的時間部分
  if (date.isValid() && time.isValid()) {
    date.set({ hour: time.get('hour'), minute: time.get('minute'), second: 0 });
  }
  // 格式化為 "YYYY-MM-DD HH:mm:ss"
  return dateString && date.isValid()
    ? date.format('YYYY-MM-DD HH:mm:ss')
    : moment(dateString).format('YYYY-MM-DD HH:mm:ss');
};

const handleDateTime = (obj, field) => {
  if (obj.key === 'Start date') {
    handle_data.value[0].section_groups[1].group_setting[0].client_view[field] = obj.val;
  }
  if (obj.key === 'Deadline') {
    handle_data.value[0].section_groups[1].group_setting[1].client_view[field] = obj.val;
  }
  if (obj.key === 'Start date' || obj.key === 'Deadline') {
    const sta = handle_data.value[0].section_groups[1].group_setting[0].client_view;
    if (sta.date) {
      handle_data.value[0].section_groups[1].group_setting[1].client_view.min_date = combineDateTime(
        sta.date,
        sta.time
      );
    }
    const dea = handle_data.value[0].section_groups[1].group_setting[1].client_view;
    if (dea.date) {
      handle_data.value[0].section_groups[1].group_setting[0].client_view.max_date = combineDateTime(
        dea.date,
        dea.time
      );
    }
    handle_data.value[0].section_groups[1].group_setting[0].client_view.val = combineDateTime(sta.date, sta.time);
    handle_data.value[0].section_groups[1].group_setting[1].client_view.val = combineDateTime(dea.date, dea.time);
  }
  if (obj.key === 'Send DateTime') {
    const group = handle_data.value[1].section_groups[obj.index];
    const timeIdx = checkTimeIndex(group);
    const sta = group.group_setting[timeIdx].client_view;
    sta[field] = obj.val;
    sta.val = combineDateTime(sta.date, sta.time);
    sta.refrash_key += 1;

    // 若修改的是 application_approved 的時間，且 Invite 已有排程時間，
    // 且 Approval 新時間晚於 Invite → 將 Invite 時間同步為 Approval 時間
    if (group.group_name === 'application_approved') {
      const inviteMode   = _getSendModeVal('application_storefront_invite');
      const approvedMode = _getSendModeVal('application_approved');
      if (inviteMode === 'scheduled' && approvedMode === 'scheduled') {
        const inviteDt = _getScheduledDatetime('application_storefront_invite');
        if (inviteDt && sta.val && sta.val > inviteDt) {
          _syncInviteToApproved();
        }
      }
    }
    // 若修改的是 application_approved 且 Invite=delay，檢查 delay 衝突後同步
    if (group.group_name === 'application_approved') {
      const inviteMode   = _getSendModeVal('application_storefront_invite');
      const approvedMode = _getSendModeVal('application_approved');
      if (inviteMode === 'scheduled' && approvedMode === 'delay') {
        const inviteDt = _getScheduledDatetime('application_storefront_invite');
        const future   = _delayToFutureDate('application_approved');
        if (inviteDt && new Date(inviteDt) < future) {
          _syncInviteToApproved();
        }
      }
    }
  }
  emit('update-data', { data: handle_data.value });
};

const calendarChange = (obj) => handleDateTime(obj, 'date');
const timeChange = (obj) => handleDateTime(obj, 'time');

const openForm = (type) => {
  switch (type) {
    case 'all':
      nav.value.selectIndex(0);
      break;
    case 'email_settings':
      nav.value.selectIndex(1);
      break;
  }
};

//+++++++++++++++++++++++++++++++++++++++++++++++++
//+++++++++++++++++++++++++++++++++++++++++++++++++
const saveTanking = (val) => {
  handle_data.value[1].section_groups[0] = val;
  emit('update-data', { data: handle_data.value });
};

const update = (obj) => {
  if (obj.key === 'thank_you_message') {
    const key = obj.spec ? Number(obj.spec) : 0;
    handle_data.value[1].section_groups[0].group_setting[key].client_view.temp_val = obj.val;
  }
  if (obj.spec === 'age-check') {
    handle_data.value[3].section_groups[1].error_msg = '';
    const key = obj.key === 'auto_rejection_age_min' ? 0 : 1;
    handle_data.value[3].section_groups[1].group_setting[key].client_view.val = obj.val;
    if (key === 0) {
      handle_data.value[3].section_groups[1].group_setting[key].client_view.err = '';
    }
    checkAge();
  }
  const handleCheckFollow = () => {
    if (!checkFollow() && followIndex.value === 0) {
      checkFollowIndex();
    }
  };
  if (obj.spec === 'tk-follow') {
    handle_data.value[3].section_groups[3].group_setting.forEach((e) => {
      if (e.label === 'auto_rejection_social_follower_count_tiktok_min') {
        e.client_view.val = obj.val;
      }
    });
    handleCheckFollow();
  }
  if (obj.spec === 'ig-follow') {
    handle_data.value[3].section_groups[3].group_setting.forEach((e) => {
      if (e.label === 'auto_rejection_social_follower_count_instagram_min') {
        e.client_view.val = obj.val;
      }
    });
    handleCheckFollow();
  }
  emit('update-data', { data: handle_data.value });
};

const checkFollow = () => {
  const settings = handle_data.value[3].section_groups[3].group_setting;
  let hasTikTok = false;
  let hasInstagram = false;
  settings.forEach((e) => {
    if (e.label === 'auto_rejection_social_follower_count_tiktok_min') hasTikTok = e.client_view.val;
    if (e.label === 'auto_rejection_social_follower_count_instagram_min') hasInstagram = e.client_view.val;
  });
  return hasTikTok && hasInstagram;
};

//---------------------------------
//10703-new

const toggleEnableActivation = () => {
  enableActivationSwitch.value = !enableActivationSwitch.value;
  const autoActivation = handle_data.value[1].section_groups.find((e) => e.group_name === 'auto_enable_account_activation');
  if (autoActivation) autoActivation.is_switch = enableActivationSwitch.value;
  if (enableActivationSwitch.value) {
    const storefront = handle_data.value[1].section_groups.find((e) => e.group_name === 'application_storefront_invite');
    if (storefront) storefront.is_switch = false;
  }
  emit('update-data', { data: handle_data.value });
};

const switchOneResonse = (val) => {
  val.is_switch = !val.is_switch;
  const arr = handle_data.value[1].section_groups.filter((e) => e.tip === 'application');
  const findSomeSwitch = arr.some((e) => e.is_switch);
  const findAllNotSwitch = arr.every((e) => !e.is_switch);
  if (findSomeSwitch) {
    auto_email.value = true;
  } else if (findAllNotSwitch) {
    auto_email.value = false;
  }
  emit('update-data', { data: handle_data.value });
};

// ════════════════════════════════════════════════════════════════════
// Invite / Approval 時間驗證核心區
// 天條：Invite 日期不得早於 Approval 日期
// ════════════════════════════════════════════════════════════════════

const _getGroup = (groupName) =>
  handle_data.value[1]?.section_groups?.find((e) => e.group_name === groupName);

const _getSendModeVal = (groupName) => {
  const g = _getGroup(groupName);
  if (!g) return null;
  const idx = checkScIndex(g);
  return idx !== -1 ? g.group_setting[idx]?.client_view?.val : null;
};

const _getScheduledDatetime = (groupName) => {
  const g = _getGroup(groupName);
  if (!g) return null;
  const idx = checkTimeIndex(g);
  return idx !== -1 ? g.group_setting[idx]?.client_view?.val : null;
};

const _toMinutes = (val, unit) => {
  const n = Number(val) || 1;
  return n * ({ minutes: 1, hours: 60, days: 1440 }[unit] || 1);
};

const _getDelayMinutes = (groupName) => {
  const g = _getGroup(groupName);
  if (!g) return 0;
  const unitIdx = checkDelayUnitIndex(g);
  const valIdx  = checkDelayValIndex(g);
  if (unitIdx === -1 || valIdx === -1) return 0;
  return _toMinutes(
    g.group_setting[valIdx].client_view.val,
    g.group_setting[unitIdx].client_view.val || 'minutes'
  );
};

// delay 分鐘數換算為當前時刻後的 Date（用於跨模式比較）
const _delayToFutureDate = (groupName) => {
  const mins = _getDelayMinutes(groupName);
  return new Date(Date.now() + mins * 60 * 1000);
};

// ─── 同步 Invite 時間為 Approval 時間 ─────────────────────────────
// 用於：Approval 改晚時把 Invite 拉平
const _syncInviteToApproved = () => {
  const inviteG   = _getGroup('application_storefront_invite');
  const approvedG = _getGroup('application_approved');
  if (!inviteG || !approvedG) return;

  const inviteMode   = _getSendModeVal('application_storefront_invite');
  const approvedMode = _getSendModeVal('application_approved');

  // Invite=scheduled, Approved=scheduled → 直接複製 scheduled datetime
  if (inviteMode === 'scheduled' && approvedMode === 'scheduled') {
    const approvedCv = approvedG.group_setting[checkTimeIndex(approvedG)].client_view;
    const inviteCv   = inviteG.group_setting[checkTimeIndex(inviteG)].client_view;
    inviteCv.val      = approvedCv.val;
    inviteCv.date     = approvedCv.date;
    inviteCv.time     = approvedCv.time;
    inviteCv.refrash_key = (inviteCv.refrash_key || 0) + 1;
  }

  // Invite=scheduled, Approved=delay → 把 Invite scheduled 改為 Approval delay 推算時間
  if (inviteMode === 'scheduled' && approvedMode === 'delay') {
    const future = _delayToFutureDate('application_approved');
    const fmtDate = moment(future).format('YYYY-MM-DD');
    const fmtTime = moment(future).format('HH:mm:ss');
    const inviteCv = inviteG.group_setting[checkTimeIndex(inviteG)].client_view;
    inviteCv.date = fmtDate;
    inviteCv.time = fmtTime;
    inviteCv.val  = moment(future).format('YYYY-MM-DD HH:mm:ss');
    inviteCv.refrash_key = (inviteCv.refrash_key || 0) + 1;
  }

  // Invite=delay, Approved=delay → 把 Invite delay 改為與 Approved 相同
  if (inviteMode === 'delay' && approvedMode === 'delay') {
    const approvedUnitIdx = checkDelayUnitIndex(approvedG);
    const approvedValIdx  = checkDelayValIndex(approvedG);
    const inviteUnitIdx   = checkDelayUnitIndex(inviteG);
    const inviteValIdx    = checkDelayValIndex(inviteG);
    if (approvedUnitIdx !== -1 && inviteUnitIdx !== -1) {
      inviteG.group_setting[inviteUnitIdx].client_view.val = approvedG.group_setting[approvedUnitIdx].client_view.val;
    }
    if (approvedValIdx !== -1 && inviteValIdx !== -1) {
      inviteG.group_setting[inviteValIdx].client_view.val = approvedG.group_setting[approvedValIdx].client_view.val;
    }
  }
};

// 檢查 group 的 scheduled 時間是否已過，回傳警告 HTML 字串或 null
const scheduledPastWarning = (v) => {
  if (!v || checkScIndex(v) === -1 || checkTimeIndex(v) === -1) return null;
  if (v.group_setting[checkScIndex(v)].client_view.val !== 'scheduled') return null;
  const val = v.group_setting[checkTimeIndex(v)].client_view.val;
  if (!val) return null;
  const dt = moment(val);
  if (!dt.isValid() || dt.isAfter(moment())) return null;
  const formatted = dt.format('h:mm A [on] MMM D, YYYY');
  return `The scheduled time ${formatted} has already passed. If published now, this email will <strong>not send automatically</strong>. <span class='under_line'>Please select other available time today or choose a future date.</span>`;
};

// ─── 錯誤訊息 computed ────────────────────────────────────────────
// 返回空字串表示無錯誤；有錯誤時同時 emit 阻止存檔
const inviteTimeError = computed(() => {
  if (!handle_data.value[1]) return '';

  const inviteG   = _getGroup('application_storefront_invite');
  const approvedG = _getGroup('application_approved');
  if (!inviteG || !approvedG) return '';
  if (!inviteG.is_switch) return ''; // invite 未開啟不需要檢查

  const inviteMode   = _getSendModeVal('application_storefront_invite');
  const approvedMode = _getSendModeVal('application_approved');

  // ── Approval = immediately ──────────────────────────────────────
  // Invite = scheduled：時間不可早於當下（由 DateTimePicker min_date 限制，無需文字錯誤）
  // Invite = delay：不影響 → 無錯誤

  // ── Approval = scheduled ────────────────────────────────────────
  if (approvedMode === 'scheduled') {
    // Invite = immediately → 錯誤
    if (inviteMode === 'immediately') {
      return `Invitation must be scheduled <strong>after</strong> the approval email.Creators may receive their invitation before knowing they've been approved. <span class='under_line'>Please reschedule the invite email tosend after the approval email.</span>`;
    }
    // Invite = scheduled → Invite 不可早於 Approval
    if (inviteMode === 'scheduled') {
      const approvedDt = _getScheduledDatetime('application_approved');
      const inviteDt   = _getScheduledDatetime('application_storefront_invite');
      if (approvedDt && inviteDt && inviteDt < approvedDt) {
        return `Invitation must be scheduled <strong>after</strong> the approval email.Creators may receive their invitation before knowing they've been approved. <span class='under_line'>Please reschedule the invite email tosend after the approval email.</span>`;
      }
    }
    // Invite = delay → 不影響
  }

  // ── Approval = delay ────────────────────────────────────────────
  if (approvedMode === 'delay') {
    // Invite = immediately → 錯誤
    if (inviteMode === 'immediately') {
       return `Invitation must be scheduled <strong>after</strong> the approval email.Creators may receive their invitation before knowing they've been approved. <span class='under_line'>Please reschedule the invite email tosend after the approval email.</span>`;
    }
    // Invite = scheduled → 不可早於 Approval delay 從現在算的時間
    if (inviteMode === 'scheduled') {
      const inviteDt      = _getScheduledDatetime('application_storefront_invite');
      const approvalFuture = _delayToFutureDate('application_approved');
      if (inviteDt && new Date(inviteDt) < approvalFuture) {
        return `Invitation must be scheduled <strong>after</strong> the approval email.Creators may receive their invitation before knowing they've been approved. <span class='under_line'>Please reschedule the invite email tosend after the approval email.</span>`;
      }
    }
    // Invite = delay → Invite delay 不可早於 Approval delay
    if (inviteMode === 'delay') {
      if (_getDelayMinutes('application_storefront_invite') < _getDelayMinutes('application_approved')) {
        return `Invitation must be scheduled <strong>after</strong> the approval email.Creators may receive their invitation before knowing they've been approved. <span class='under_line'>Please reschedule the invite email tosend after the approval email.</span>`;
      }
    }
  }

  return '';
});

// Invite=scheduled 時，DateTimePicker 的 min_date
// - Approval=immediately → 限制不早於現在
// - Approval=scheduled   → 限制不早於 Approval 選定時間
// - Approval=delay       → 限制不早於 Approval delay 換算的未來時間
const inviteScheduledMinDate = computed(() => {
  const approvedMode = _getSendModeVal('application_approved');
  if (approvedMode === 'scheduled') {
    return _getScheduledDatetime('application_approved') || moment().format('YYYY-MM-DD HH:mm:ss');
  }
  if (approvedMode === 'delay') {
    return moment(_delayToFutureDate('application_approved')).format('YYYY-MM-DD HH:mm:ss');
  }
  // immediately or null → 不早於現在
  return moment().format('YYYY-MM-DD HH:mm:ss');
});

// 監聽錯誤，向上傳遞阻止存檔
// 任一 scheduled group 時間過去 → 也視為錯誤
const anyScheduledPastError = computed(() => {
  if (!handle_data.value?.[1]?.section_groups) return false;
  return handle_data.value[1].section_groups
    .filter(g => g.tip === 'application')
    .some(g => !!scheduledPastWarning(g));
});

// 合併兩個錯誤來源，只要其一有錯就通知外層
const hasAnyTimeError = computed(() => !!inviteTimeError.value || anyScheduledPastError.value);

//new code
watch(hasAnyTimeError, (val) => {
  emit('invite-time-error', val);
});

// 監聽 Approval delay 值/單位變化 → 若 Invite 衝突則同步
watch(
  () => {
    const g = _getGroup('application_approved');
    if (!g) return null;
    const ui = checkDelayUnitIndex(g);
    const vi = checkDelayValIndex(g);
    return ui !== -1 && vi !== -1
      ? `${g.group_setting[vi].client_view.val}_${g.group_setting[ui].client_view.val}`
      : null;
  },
  () => {
    const inviteMode   = _getSendModeVal('application_storefront_invite');
    const approvedMode = _getSendModeVal('application_approved');
    if (approvedMode !== 'delay' || !_getGroup('application_storefront_invite')?.is_switch) return;

    // Invite=delay：若 Invite delay < Approved delay → 同步
    if (inviteMode === 'delay') {
      if (_getDelayMinutes('application_storefront_invite') < _getDelayMinutes('application_approved')) {
        _syncInviteToApproved();
        emit('update-data', { data: handle_data.value });
      }
    }
    // Invite=scheduled：若 Invite scheduled < Approved delay future → 同步
    if (inviteMode === 'scheduled') {
      const inviteDt = _getScheduledDatetime('application_storefront_invite');
      const future   = _delayToFutureDate('application_approved');
      if (inviteDt && new Date(inviteDt) < future) {
        _syncInviteToApproved();
        emit('update-data', { data: handle_data.value });
      }
    }
  }
);

// ─── send mode 切換邏輯 ───────────────────────────────────────────
// 1. 切換時清空不再使用的欄位
// 2. Invite 切換後立即做衝突檢查；Approval 切換後若造成衝突，同步 Invite 時間

const _clearScheduledFields = (v) => {
  const timeIdx = checkTimeIndex(v);
  if (timeIdx === -1) return;
  const cv = v.group_setting[timeIdx].client_view;
  cv.val = ''; cv.date = ''; cv.time = ''; cv.max_date = null;
};

const _clearDelayFields = (v) => {
  const unitIdx = checkDelayUnitIndex(v);
  const valIdx  = checkDelayValIndex(v);
  if (unitIdx !== -1) v.group_setting[unitIdx].client_view.val = 'minutes';
  if (valIdx  !== -1) v.group_setting[valIdx].client_view.val  = 1;
};

const handleSendModeChange = (v, newMode) => {
  // 清空不對應的欄位
  if (newMode !== 'scheduled') _clearScheduledFields(v);
  if (newMode !== 'delay')     _clearDelayFields(v);

  emit('update-data', { data: handle_data.value });
};
//---------------------------------

//---------------------------------
//switch auto reject
const handleSocAlert = (val) => {
  if ((val === 'tk' && autoRejDis.value.tk_f) || (val === 'ig' && autoRejDis.value.ig_f)) {
    is_show_alert2_modal.value = true;
    alert.header = 'Social Account field is required on your form.';
    alert.text = `<p>To use this feature, follower data is required. Please add to the <span style="font-weight: 800">Social Account</span> section to your application and <span style="font-weight: 800">enable</span> authentication to continue.</p>`;
    alert.img = require('@/assets/images/social.png');
  }
};

const switchOneAuto = (index, is_disabled) => {
  if (is_disabled && index !== 0) {
    is_show_alert2_modal.value = true;
    if (index === 1) {
      alert.header = 'Enable the Age field to use this feature.';
      alert.text = `<p>To use this feature, applicant age data is required. Please enable the <span style="font-weight: 800">Age</span> field under <span style="font-weight: 800">'Edit Application > Basic Info'</span> to continue.</p>`;
      alert.img = require('@/assets/images/birthday.png');
    } else if (index === 2) {
      alert.header = 'Enable the Country/Location field to use this feature.';
      alert.text = `<p>To use this feature, applicant location data is required. Please enable the <span style="font-weight: 800">Country/Location</span> field under <span style="font-weight: 800">'Edit Application > Basic'</span> Info to continue.</p>`;
      alert.img = require('@/assets/images/location.png');
    } else {
      alert.header = 'Social Account field is required on your form.';
      alert.text = `<p>To use this feature, follower data is required. Please add to the <span style="font-weight: 800">Social Account</span> section to your application and <span style="font-weight: 800">enable</span> authentication to continue.</p>`;
      alert.img = require('@/assets/images/social.png');
    }
  } else {
    if (index === 0) {
      if (handle_data.value[3].section_groups[index].is_switch) {
        handle_data.value[3].section_groups.forEach((e) => {
          e.is_switch = false;
        });
      } else {
        handle_data.value[3].section_groups.forEach((e, k) => {
          if (k === 0) e.is_switch = true;
          if (!is_disabled.age && k === 1) e.is_switch = handle_data.value[3].section_groups[index].is_switch;
          if (!is_disabled.loc && k === 2) e.is_switch = handle_data.value[3].section_groups[index].is_switch;
          if (!is_disabled.follow && k === 3) e.is_switch = handle_data.value[3].section_groups[index].is_switch;
        });
      }
    } else {
      handle_data.value[3].section_groups[index].is_switch = !handle_data.value[3].section_groups[index].is_switch;
    }
    if (index !== 0) {
      //handle all switch
      const arr = handle_data.value[3].section_groups.filter((e, k) => k !== 0);
      const findSomeSwitch = arr.some((e) => e.is_switch);
      const findAllNotSwitch = arr.every((e) => !e.is_switch);
      if (findSomeSwitch) {
        handle_data.value[3].section_groups[0].is_switch = true;
      } else if (findAllNotSwitch) {
        handle_data.value[3].section_groups[0].is_switch = false;
      }
    }
    const hanBox = handle_data.value[3].section_groups[index];
    if (index === 1 && !hanBox.is_switch) {
      hanBox.error_msg = '';
      hanBox.group_setting.forEach((e) => {
        if (e.client_view) e.client_view.val = '';
      });
    }
    if (index === 3 && !hanBox.is_switch) {
      hanBox.group_setting.forEach((e) => {
        if (e.client_view) {
          e.client_view.val = '';
          if (e.client_view.error_msg) e.client_view.error_msg = '';
        }
      });
    }
    //目前為固定的位子
    const rej_location_open = index === 2 ? handle_data.value[3].section_groups[index].is_switch : null;
    emit('update-data', { data: handle_data.value, rej_open: rej_location_open });
  }
};

const updateLocation = (obj) => {
  handle_data.value[3].section_groups[2].group_setting[0].client_view.input_option = obj;
  handle_data.value[3].section_groups[2].group_setting[0].client_view.val = obj.filter((e) => e.click);
  emit('update-data', { data: handle_data.value });
};

const remove = (val) => {
  handle_data.value[3].section_groups[2].group_setting[0].client_view.input_option =
    handle_data.value[3].section_groups[2].group_setting[0].client_view.input_option.map((item) =>
      item.id === val.id ? { ...item, click: false } : item
    );
  handle_data.value[3].section_groups[2].group_setting[0].client_view.val =
    handle_data.value[3].section_groups[2].group_setting[0].client_view.val.filter((item) => item.id !== val.id);
  emit('update-data', { data: handle_data.value });
};

const updateDataInSide = () => {
  emit('update-data', { data: handle_data.value });
};

//++++++++++++++++++++++++++++++++++++++++++
//saveing
//++++++++++++++++++++++++++++++++++++++++++
const saveTitle = (val) => {
  if (val.type === 'edit') {
    const value = val.val;
    handle_data.value[0].section_groups[0].group_setting[0].input_value = value.application_title;
    handle_data.value[0].section_groups[0].group_setting[1].input_value = value.application_url;
    handle_data.value[0].section_groups[0].group_setting[2].input_value = value.create_tag;
    handle_data.value[0].section_groups[0].group_setting[3].input_value = value.meta_description;
    emit('update-data', { data: handle_data.value, refrash_key: true });
    store.state.is_loading = false;
  }
};

const emailSave = (val) => {
  handle_data.value = val;
  emit('update-data', { data: handle_data.value });
};

const clearRedDot = (field) => {
  if (props.ambassador_application_id === 1 || !props.ambassador_application_id) {
    is_new_map.value[field] = false;
    return;
  }

  if(is_new_map.value[field] ){
    ajax.post('/ambassador/section-seen', {
      ambassador_application_id: props.ambassador_application_id,
      section_key: field,
    }).then(() => {
      is_new_map.value[field] = false;
    });
  }
};

const clearTabRedDot = () => {
  if(tab_index.value===2){
    clearRedDot('automations');
  }else if(tab_index.value===3){
    clearRedDot('emails');
  }
};

const clearEmailRedDot = (v) => {
  if (v.group_name in is_new_map.value) {
     clearRedDot(v.group_name);
  }
};

const sendTestEmail = (v) => {
  editResTemplate.value.edit_index = v.index;
  editResTemplate.value.senaAEmail();
};

//++++++++++++++++++++++++++++++++++++++++++
//other
//++++++++++++++++++++++++++++++++++++++++++
const checkAge = () => {
  const min = handle_data.value[3].section_groups[1].group_setting[0].client_view.val;
  const max = handle_data.value[3].section_groups[1].group_setting[1].client_view.val;
  const integerPattern = /^\d*$/;
  if ((min && !integerPattern.test(min)) || (max && !integerPattern.test(max))) {
    handle_data.value[3].section_groups[1].error_msg = 'You can only enter integers.';
    return;
  }
  if (min && max) {
    if (Number(max) < Number(min)) {
      handle_data.value[3].section_groups[1].error_msg = 'The maximum age cannot be less than the minimum age.';
    }
  }
};

const checkFollowIndex = () => {
  followIndex.value = followIndex.value === 0 ? 1 : 0;
  handle_data.value[3].section_groups[3].group_setting.forEach((e) => {
    if (e.label === 'auto_rejection_social_follower_count_condition') {
      e.client_view.val = followIndex.value === 0 ? 'AND' : 'OR';
    }
  });
  emit('update-data', { data: handle_data.value });
};


// ─── lifecycle ────────────────────────────────────────────────────
onMounted(() => {
  getData();
});


defineExpose({ openForm });
</script>

<style lang="scss">
.select-above-modal {
  z-index: 9995 !important;
}

@mixin flexCenter() {
  display: flex;
  align-items: center;
}

.prog-set-form-right-wrap {
  .pick-date-box .mx-datepicker {
    width: 100% !important;
  }

  .tab-head {
    color: var(--black-90);
    position: sticky;
    top: 0;
    background-color: white;
    padding: 16px 24px 0;
    z-index: 99;
    margin-bottom: 16px;

    h2 {
      font: var(--font-med-24);
      margin: 0 0 8px;
    }

    .ui-navi {
      flex: 1;

      .link {
        height: 36px;
        white-space: nowrap;
        font: var(--font-med-14);
        position: relative;
      }
    }

    &.tab-head-show-all {
      background-color: white;
      border-radius: 6px 6px 0 0;
      padding: 16px 16px 0;
      border-bottom: solid 1px var(--border);
      margin-bottom: 0;

      .tab-head-top {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .tab-head-title {
          font: var(--font-demi-24);
          color: var(--black-90);
          flex: 1;
        }

        .tab-head-close {
          width: 14px;
          height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .svg-icon {
            width: 12px;
            height: 12px;
            fill: var(--black-50);
          }
        }
      }
    }
  }

  .nav-red-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background-color: var(--alert);
    border-radius: 50%;
    margin-left: 2px;
    vertical-align: super;
    font-size: 0;
  }

  .foot-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 24px;

    .ui-button {
      margin-left: 16px;
    }
  }

  .time-conflict-warning {
    display: flex;
    gap: 8px;
    margin-top: 8px;
    padding: 8px 12px;
    background-color: #fffbe6;
    border-radius: 4px;
    color:var(--Text-primary);

    svg{
      width: 12px;
      height: 12px;
      min-width: 12px;
      margin-top: 4px;
      fill:var(--Text-primary);
    }
    strong {
      font-weight:800;
    }
    p{
      font-size: 12px;
      margin: 0;
      .under_line {
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }

  .svg-icon {
    width: 14px;
    height: 14px;
    cursor: pointer;
  }

  .red {
    color: var(--red);
  }

  .data-list-right {
    height: calc(100vh - 48px);
  }

  .big-title {
    font: var(--font-med-20);
    color: var(--white);
  }

  .set-box {
    background: var(--white);
    border-radius: 6px;
    margin-top: 16px;
    padding: 8px 12px;

    &:last-child {
      margin-bottom: 36px;
    }

    .title-top {
      @include flexCenter();
      justify-content: space-between;
      margin-bottom: 16px;

      .title {
        font: var(--font-med-20);
      }
    }

    .url-link-one-line {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      display: block;
    }

    .desc {
      font-size: 12px;
      color: var(--black-75);
      margin: 8px 0;
      flex: 1;
      // word-break: break-all;
    }

    .content-box {
      padding: 0 0 16px;

      .small-title-box {
        @include flexCenter();

        p {
          font: var(--font-med-16);
          flex: 1;
        }

        .small-title-box-right {
          @include flexCenter();
        }

        .open-pre {
          color: var(--blue);
          font-size: 12px;
          cursor: pointer;
          margin-right: 4px;
        }
      }

      .switch-open-content{
        border-left: solid 2px var(--black-20);
        padding-left: 12px;
      }

      .sub-mes-box {
        @include flexCenter();

        .s-tit {
          font-size: 14px;
          width: 48px;
          min-width: 48px;
          margin-right: 10px;
        }
        .desc,
        .the-input {
          flex: 1;
          margin-right: 10px;
        }
      }

      .small-text {
        @include flexCenter();
        font: var(--font-med-16);
        justify-content: space-between;

        &.had-required{
          justify-content: unset;
        }

        .required-red {
          color: var(--red);
        }

        .small-text-left {
          @include flexCenter();
          gap: 6px;
          flex: 1;

          .tip-icon {
            width: 12px;
            height: 12px;
            color: var(--Text-default);
            cursor: pointer
          }
        }

        .switch-with-label {
          @include flexCenter();
          gap: 8px;
          flex-shrink: 0;

          .switch-state-text {
            font-size: 12px;
            color: var(--Text-default);
          }
        }

        .small-btn {
          @include flexCenter();
          height: unset;
          color: var(--green);
          border: solid 1px var(--border);

          .svg-icon {
            fill: var(--green);
            margin-right: 4px;
          }
        }

        &.small-text-disabeld {
        }
      }

      .small-text-dec {
        font-size: 14px;
      }

      .auto-rej-content .small-text{
        font:var(--font-med-14);
      }


      .url {
        color: var(--blue);
        font-size: 12px;
      }

      .text-box {
        margin-top: 12px;
        &:first-child {
          margin-top: 0;  
        }
      }

      .ui-input {
        margin: 4px 0;
      }

      .date-box {
        margin-top: 8px;

        .title {
          @include flexCenter();
          justify-content: space-between;
          font: var(--font-med-12);
          margin-bottom: 6px;
        }
        .title-left{
          display: flex;
          align-items: center;
          gap: 6px;

          svg{
            fill:var(--Text-default);
            width: 12px;
            height: 12px;
          }
        }

        .desc {
          margin: 4px 0;
        }
      }

      .value-box {
        @include flexCenter();

        .left-text {
          font: var(--font-med-12);
          width: 32px;
        }

        .ui-input {
          flex: 1;
          margin-left: 8px;
        }

        &.value-box-err {
          .ui-input {
            border: solid 1px var(--red);
          }
        }
      }

      .select-box {
        .item-box {
          width: 100%;
        }

        .scrollbar-content {
          height: 240px;
        }

        .svg-icon {
          width: 12px;
          height: 12px;
        }

        .ui-button {
          justify-content: flex-start;
        }
      }

      .err-msg {
        font-size: 12px;
        font-weight: 500;
        color: var(--alert);
        text-align: right;
      }

      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 4px;

        .ul-box {
          display: flex;
          flex-wrap: wrap;
          gap: 4px 8px;
          align-items: center;

          li {
            display: inline-flex;
            align-items: center;

            i {
              height: 14px;
              width: 14px;
              margin-left: 4px;
              cursor: pointer;
              border: none;

              svg {
                height: 100%;
                width: 100%;
                margin: 0;
                fill: var(--red);
              }
            }
            span {
              font: var(--font-med-12);
              display: flex;
              align-items: center;
            }
          }
        }
      }

      .flex {
        @include flexCenter();
        flex: 1;
        .ui-input {
          width: 100%;
        }
      }
    }

    .application-handle {
      padding-left: 8px;
      border-left: solid 2px var(--neutral);

      .sch-label {
        font-size: 12px;
        color: var(--black-75);
        margin: 8px 0 4px;
      }

      .btn-sch-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 4px;

        .btn {
          @include flexCenter();
          justify-content: center;
          font: var(--font-med-12);
          border: solid 1px var(--neutral);
          height: 30px;
          border-radius: 6px;
          cursor: pointer;
          transition: 0.3s;

          .svg-icon {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }

          &.pick-btn {
            border: solid 1px var(--dark-blue);
          }
        }
      }

      .edit-box {
        @include flexCenter();
        transition: 0.3s;
        border-radius: 6px;
        padding: 4px;
        cursor: pointer;
        margin-top: 4px;
        font: var(--font-med-12);
        width: fit-content;

        &.edit-box-red {
          color: var(--red);
        }

        &:hover {
          background-color: var(--light-neutral);
        }

        .svg-icon {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }

        &.dis-edit-box {
          pointer-events: none;
          cursor: not-allowed;
          opacity: 0.7;
        }
      }
    }

    .date-time-pick-box-err {
      .pick-date-box input {
        border: solid 1px var(--red);
      }
    }
  }

  .submit-btn {
    width: 100%;
  }

  .account-type-section {
    margin-top: 12px;

    .req {
      color: var(--alert);
    }

    .note {
      text-decoration: underline;
    }

    .account-type-checks {
      display: flex;
      gap: 20px;
      margin-top: 8px;
    }

    .account-type-check-label {
      display: flex;
      align-items: center;
      gap: 6px;
      color: var(--black-90);
      cursor: pointer;
      font: var(--font-med-14);

      input[type='checkbox'] {
        width: 14px;
        height: 14px;
        cursor: pointer;
        accent-color: var(--dark-blue);

        &:disabled {
          cursor: not-allowed;
        }
      }
    }
  }

  .automation-group-title {
    font: var(--font-med-16);
    margin-top: 16px;
    margin-bottom: 6px;

    &:first-child {
      margin-top: 0;
    }
  }

  .auto-item {
    padding: 8px 0;

    .auto-row {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .auto-row-left {
        display: flex;
        align-items: center;
        gap: 6px;
        font: var(--font-med-14);
        flex: 1;
        padding-right: 8px;

        svg{
          fill: var(--Text-default);
          width: 12px;
          height: 12px;
        }
      }
    }

    .tip-q {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid var(--black-40);
      font-size: 10px;
      color: var(--black-40);
      cursor: default;
      flex-shrink: 0;
    }

    .manual-tag {
      font: var(--font-regular-12);
      color: var(--black-50);
      background: var(--black-10);
      border-radius: 4px;
      padding: 1px 6px;
      white-space: nowrap;
    }

    .sch-label {
      font-size: 12px;
      color: var(--black-75);
      margin: 8px 0 4px;
    }

    .sch-select {
      width: 100%;

      .el-input__wrapper {
        border-radius: 6px;
      }
    }

    .date-time-pick-box { margin-top: 8px; }

    .delay-box {
      margin-top: 8px;

      .desc {
        font-size: 12px;
        color: var(--black-75);
        margin-bottom: 6px;
      }

      .delay-inputs {
        display: flex;
        gap: 8px;
        align-items: center;

        .delay-num-input {
          width: 80px;
          height: 32px;
          border: 1px solid var(--black-20);
          border-radius: 6px;
          padding: 0 10px;
          font-size: 14px;
          color: var(--black);
          outline: none;
          flex-shrink: 0;

          &::-webkit-inner-spin-button,
          &::-webkit-outer-spin-button {
            opacity: 1;
          }
        }

        .delay-unit-select {
          flex: 1;

          .el-input__wrapper {
            border-radius: 6px;
          }
        }
      }

      .delay-hint {
        margin-top: 4px;
        font-size: 11px;
        color: var(--black-50);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 4px;
        width: 100%;

        &::before {
          content: '';
          display: inline-block;
          width: 14px;
          height: 14px;
          background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Ccircle cx='8' cy='8' r='7' stroke='%2399a' stroke-width='1.5' fill='none'/%3E%3Cpath d='M8 4.5v4M8 10.5v1' stroke='%2399a' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat center / contain;
          flex-shrink: 0;
        }
      }
    }
  }

  .auto-rej-box {
    .auto-rej-title-wrap {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .tip-q {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid var(--black-40);
      font-size: 10px;
      color: var(--black-40);
      cursor: default;
      flex-shrink: 0;
    }
  }

  // Emails tab styles
  .emails-content {
    .email-row {
      padding-top: 4px;
      padding-bottom: 4px;
      &:last-child{
        padding-bottom: 0;
      }

      .email-row-title {
        font: var(--font-med-14);
        display: block;
        margin-bottom: 6px;
        &.row-title-big{
          font: var(--font-med-16);
        }
      }

      .email-row-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;

        .send-test-link {
          font:var(--font-med-12);
          color: var(--blue);
          cursor: pointer;
          white-space: nowrap;

          &:hover {
            text-decoration: underline;
          }
        }

        .edit-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          font: var(--font-med-12);
          cursor: pointer;
          padding: 4px 8px;
          border-radius: 4px;
          position: relative;
          white-space: nowrap;

          &:hover {
            background-color: var(--light-neutral);
          }

          &.dis-edit-box {
            pointer-events: none;
            opacity: 0.7;
          }

          .svg-icon {
            width: 12px;
            height: 12px;
          }

          .dot-badge {
            width: 6px;
            height: 6px;
            background: var(--alert);
            border-radius: 50%;
            position: absolute;
            top: 2px;
            right: 2px;
          }
        }
      }
    }

    .email-section-group {
      margin-top: 20px;

      .email-section-group-title {
        font: var(--font-med-16);
        margin-bottom: 0;
      }
    }
  }

  .follow-check {
    align-items: flex-start;

    .svg-icon {
      min-width: 12px;
      margin-top: 2px;
    }
  }
}

.application-alert-modal2 {
  .delete-header {
    font: var(--font-med-16);
    padding: 16px 24px;
    display: flex;
    gap: 16px;
    align-items: center;

    h2 {
      flex: 1;
    }

    i {
      cursor: pointer;

      svg {
        fill: var(--black-50);
        width: 14px;
        height: 14px;
      }
    }
  }

  .content {
    padding: 24px;

    img {
      width: 100%;
      height: 360px;
      margin-bottom: 24px;
    }

    h3 {
      font: var(--font-med-24);
      margin-bottom: 16px;
    }

    p {
      font-size: 16px;
      color: var(--black-90);
      margin-bottom: 24px;
    }

    .ui-button {
      width: 100%;
    }
  }
}
</style>
